import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListDeliveryVouchersActions as Actions,
  ListDeliveryVouchersRequestAction as RequestAction,
} from 'store/ducks/deliveryVouchers';

export function* listDeliveryVouchersRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = `delivery-vouchers/invoice/${query.invoiceId}`;
    const { data } = yield call(api.get, url);
    console.log('datadelivery', data);
    onSuccess && onSuccess(data);
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
